import { Box, Button, Flex, useTheme } from '@chakra-ui/react';
import RowList from '../../nesting/RowList';
import { useTeamTableContext } from '../../context/TeamTableContext';
import { AddSquareIcon, SubtractSquareIcon } from '../../../icons';
import { TeamDto } from '../../types/team-table.types';

export default function DropdownCell({
  cellData,
  subRows,
  level,
  lastVisibleName,
}: {
  cellData: TeamDto;
  level: number;
  subRows: TeamDto[];
  lastVisibleName?: string;
}) {
  const { expanded, setExpanded } = useTeamTableContext();
  const { colors } = useTheme();
  const isExpanded = expanded.includes(cellData.name);
  const isLastChild = cellData?.isLast === true;
  const isLastLastChild =
    (cellData as any)?.isLastLastChild === true ||
    (lastVisibleName !== undefined && cellData.name === lastVisibleName);

  const connectorHeight =
    level === 0
      ? isExpanded
        ? 177
        : 185
      : isLastChild && !isExpanded
      ? 152
      : isExpanded
      ? 177
      : 185;
  return (
    <>
      <Flex
        direction="column"
        minH="185px"
        minW="32px"
        bg="white"
        borderLeft="1px solid #E0E0E0"
        align={'center'}
      >
        {subRows && subRows.length === 0 && level !== 0 && (
          <Flex position={'relative'} flex={1}>
            <Box
              position={'absolute'}
              right={0}
              top={-4}
              h={185}
              w={'1px'}
              bg={colors.text.gray[100]}
              mx={'auto'}
            ></Box>
            {cellData.isLast && (
              <Box
                position="absolute"
                bottom={2}
                left={'-1px'}
                width="10px"
                height="10px"
                borderBottom={`1px solid ${colors.text.gray[100]}`}
                borderLeft={`1px solid ${colors.text.gray[100]}`}
                borderBottomLeftRadius="20px"
              />
            )}
          </Flex>
        )}
        {subRows && subRows.length > 0 && (
          <>
            <Button
              minW={'auto'}
              w={4}
              h={4}
              p={0}
              mt={level === 0 ? 2 : 0}
              onClick={() => {
                if (isExpanded) {
                  setExpanded((prev) =>
                    prev.filter((item) => item !== cellData.name)
                  );
                } else {
                  setExpanded((prev) => [...prev, cellData.name]);
                }
              }}
            >
              {isExpanded ? (
                <SubtractSquareIcon height="16" width="16" />
              ) : (
                <AddSquareIcon height="16" width="16" />
              )}
            </Button>
            <Flex position={'relative'} flex={1}>
              {(isExpanded || isLastChild) && level > 0 && (
                <Box
                  position={'absolute'}
                  top={-8}
                  right={0}
                  h={'16px'}
                  w={'1px'}
                  bg={colors.text.gray[100]}
                  mx={'auto'}
                />
              )}
              {((level === 0 && isExpanded) ||
                (level > 0 && (!isLastLastChild || isExpanded))) && (
                <Box
                  position={'absolute'}
                  right={0}
                  h={connectorHeight}
                  w={'1px'}
                  bg={colors.text.gray[100]}
                  mx={'auto'}
                />
              )}

              {/* Rounded elbow for last child with children when collapsed */}
              {level > 0 && isLastChild && !isExpanded && (
                <Box
                  position="absolute"
                  bottom={2}
                  left="-1px"
                  width="10px"
                  height="10px"
                  borderBottom={`1px solid ${colors.text.gray[100]}`}
                  borderLeft={`1px solid ${colors.text.gray[100]}`}
                  borderBottomLeftRadius="20px"
                />
              )}
            </Flex>
          </>
        )}
      </Flex>
      {subRows && subRows.length > 0 && isExpanded && (
        <RowList colKey="DROPDOWN" rows={subRows} level={level + 1} />
      )}
    </>
  );
}
